import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT, DELETE } from "../../../../../services/index";
import { message } from "antd";

export const UseFetchBlacklistTopics = () => {
  return useQuery(["blacklistTopics"], async () => {
    try {
      const { result } = await GET(`/api/v1/blacklist/topic`);
      return result || [];
    } catch (error) {
      await message.destroy();
      message.error("โหลดหัวข้อ blacklist ไม่สำเร็จ");
      return [];
    }
  });
};

export const UseCreateBlacklistTopic = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/blacklist/topic`, payload),
  });
};

export const UseUpdateBlacklistTopic = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }) =>
      await PUT(`/api/v1/blacklist/topic/${id}`, payload),
  });
};

export const UseDeleteBlacklistTopic = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/blacklist/topic/${id}`),
  });
};
